import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=eafccd72&scoped=true&"
import script from "./slider.vue?vue&type=script&lang=js&"
export * from "./slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eafccd72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/gp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eafccd72')) {
      api.createRecord('eafccd72', component.options)
    } else {
      api.reload('eafccd72', component.options)
    }
    module.hot.accept("./slider.vue?vue&type=template&id=eafccd72&scoped=true&", function () {
      api.rerender('eafccd72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "webpack/public-site-media-dunk/src/components/base/slider.vue"
export default component.exports